"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AvatarCard_styled_exports = {};
__export(AvatarCard_styled_exports, {
  StyledAppSelectorContainer: () => StyledAppSelectorContainer,
  StyledAvatarPopupWindowScroll: () => StyledAvatarPopupWindowScroll,
  StyledCard: () => StyledCard,
  StyledCloseButtonContainer: () => StyledCloseButtonContainer,
  StyledEndImpersonationButton: () => StyledEndImpersonationButton,
  StyledHeading: () => StyledHeading,
  StyledImpersonationArea: () => StyledImpersonationArea,
  StyledImpersonationTitle: () => StyledImpersonationTitle,
  StyledLinkItem: () => StyledLinkItem,
  StyledLinks: () => StyledLinks,
  StyledLinksContainer: () => StyledLinksContainer,
  StyledLinksCopyright: () => StyledLinksCopyright,
  StyledLoggedInAsUser: () => StyledLoggedInAsUser,
  StyledLoggedInAsUserLabel: () => StyledLoggedInAsUserLabel,
  StyledLogout: () => StyledLogout,
  StyledLogoutToolTip: () => StyledLogoutToolTip,
  StyledParagraph: () => StyledParagraph,
  StyledRoleBadge: () => StyledRoleBadge,
  StyledRoleContainer: () => StyledRoleContainer,
  StyledText: () => StyledText
});
module.exports = __toCommonJS(AvatarCard_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_Badge = require("../../atoms/Badge/Badge.component");
var import_Button = require("../../atoms/Button/Button.component");
var import_Card = require("../../atoms/Card/Card.component");
var import_Heading = require("../../atoms/Heading/Heading.component");
var import_Link = require("../../atoms/Link/Link.component");
var import_Paragraph = require("../../atoms/Paragraph/Paragraph.component");
var import_atoms = require("../../atoms");
var brands = {
  base: (0, import_styled_components.css)(["--gma-atm-ava-width:240px;"]),
  studentXP: (0, import_styled_components.css)(["--gma-atm-ava-width:200px;"]),
  geodes: (0, import_styled_components.css)(["--gma-atm-ava-width:200px;"])
};
var StyledCard = (0, import_styled_components.default)(import_Card.Card).withConfig({
  displayName: "AvatarCardstyled__StyledCard",
  componentId: "sc-13exct9-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["align-items:center;display:flex;flex-direction:column;justify-content:center;padding:32px 0 0;border:1px solid ", ";box-shadow:none;border-radius:0;max-height:798px;height:auto;width:auto;", ""], theme.colors.beige[140], (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["box-shadow:0px 12px 16px rgba(0,0,0,0.1);"])));
});
var StyledHeading = (0, import_styled_components.default)(import_Heading.Heading).withConfig({
  displayName: "AvatarCardstyled__StyledHeading",
  componentId: "sc-13exct9-1"
})(function(_ref2) {
  var theme = _ref2.theme, showLogoutButton = _ref2.showLogoutButton;
  return (0, import_styled_components.css)(["color:", ";margin-top:", ";word-break:break-all;width:352px;text-align:center;padding:0 2px;", ""], theme.colors.n[100], theme.measurements.medium, !showLogoutButton && "margin-bottom: 32px");
});
var StyledRoleContainer = import_styled_components.default.div.withConfig({
  displayName: "AvatarCardstyled__StyledRoleContainer",
  componentId: "sc-13exct9-2"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["display:flex;box-sizing:border-box;margin:", " ", ";justify-content:center;align-items:center;flex-direction:column;"], theme.measurements.extraLarge, theme.measurements.zero);
});
var StyledRoleBadge = (0, import_styled_components.default)(import_Badge.Badge).withConfig({
  displayName: "AvatarCardstyled__StyledRoleBadge",
  componentId: "sc-13exct9-3"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["box-sizing:border-box;width:124px;height:100%;", ";margin:8px 0px 4px 0px;font-size:", ";font-weight:", ";text-transform:capitalize;display:flex;align-items:center;justify-content:center;span{line-height:24px;letter-spacing:0px;}i{padding:0;margin-right:8px;}"], (0, import_mixins.withPadding)("medium extraLarge"), theme.typography.sizes.medium, theme.typography.weights.black);
});
var StyledLogout = (0, import_styled_components.default)(import_Button.Button).withConfig({
  displayName: "AvatarCardstyled__StyledLogout",
  componentId: "sc-13exct9-4"
})(function(_ref5) {
  var theme = _ref5.theme, brand = _ref5.brand;
  return (0, import_styled_components.css)(["", " cursor:pointer;border-color:", ";justify-content:center;width:240px;margin:16px 0 20px;font-size:14px;"], brands[brand], theme.colors.beige[180]);
});
var StyledLogoutToolTip = (0, import_styled_components.default)(import_atoms.Tooltip).withConfig({
  displayName: "AvatarCardstyled__StyledLogoutToolTip",
  componentId: "sc-13exct9-5"
})(["div[role='dialog']{text-align:center;}"]);
var StyledText = import_styled_components.default.div.withConfig({
  displayName: "AvatarCardstyled__StyledText",
  componentId: "sc-13exct9-6"
})(function(_ref6) {
  var theme = _ref6.theme;
  return (0, import_styled_components.css)(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";"], theme.typography.fonts.primary, theme.typography.sizes.small, theme.typography.weights.regular, theme.typography.sizes.small);
});
var StyledLinksCopyright = import_styled_components.default.div.withConfig({
  displayName: "AvatarCardstyled__StyledLinksCopyright",
  componentId: "sc-13exct9-7"
})(function(_ref7) {
  var theme = _ref7.theme;
  return (0, import_styled_components.css)(["background-color:", ";width:100%;height:auto;border-top:1px solid rgb(196,194,170);box-sizing:border-box;", ";a:link{line-height:20px;}"], theme.colors.beige[60], (0, import_mixins.withPadding)("extraLarge"));
});
var StyledLinksContainer = import_styled_components.default.ul.withConfig({
  displayName: "AvatarCardstyled__StyledLinksContainer",
  componentId: "sc-13exct9-8"
})(function() {
  return (0, import_styled_components.css)(["display:flex;flex-wrap:wrap;justify-content:center;list-style-type:none;margin:auto;padding:0;max-width:290px;gap:16px;"]);
});
var StyledLinkItem = import_styled_components.default.li.withConfig({
  displayName: "AvatarCardstyled__StyledLinkItem",
  componentId: "sc-13exct9-9"
})(function(_ref8) {
  var theme = _ref8.theme;
  return (0, import_styled_components.css)(["letter-spacing:0.5px;line-height:", ";&:first-child{& > a{font-weight:", ";}}"], theme.measurements.extraLarge, theme.typography.weights.bold);
});
var StyledLinks = (0, import_styled_components.default)(import_Link.Link).withConfig({
  displayName: "AvatarCardstyled__StyledLinks",
  componentId: "sc-13exct9-10"
})(function(_ref9) {
  var theme = _ref9.theme;
  return (0, import_styled_components.css)(["color:", ";font-size:", ";line-height:", " !important;text-decoration:none;text-transform:uppercase;i{margin-left:", ";}"], theme.colors.primary[0], theme.typography.sizes.extraSmall, theme.typography.sizes.medium, theme.measurements.small);
});
var StyledParagraph = (0, import_styled_components.default)(import_Paragraph.Paragraph).withConfig({
  displayName: "AvatarCardstyled__StyledParagraph",
  componentId: "sc-13exct9-11"
})(function(_ref10) {
  var theme = _ref10.theme;
  return (0, import_styled_components.css)(["color:", ";letter-spacing:1px;line-height:", ";", ";text-align:center;"], theme.colors.n[100], theme.measurements.extraLarge, (0, import_mixins.withPadding)("extraLarge zero zero"));
});
var StyledCloseButtonContainer = import_styled_components.default.div.withConfig({
  displayName: "AvatarCardstyled__StyledCloseButtonContainer",
  componentId: "sc-13exct9-12"
})(function(_ref11) {
  var theme = _ref11.theme;
  var popupStyle = (0, import_styled_components.css)(["margin-top:-32px;box-sizing:border-box;width:100%;height:48px;background-color:", ";display:flex;justify-content:end;align-items:center;border-bottom:none;button{margin-right:4px;}"], theme.colors.white);
  return (0, import_styled_components.css)(["", ""], popupStyle);
});
var StyledImpersonationArea = import_styled_components.default.div.withConfig({
  displayName: "AvatarCardstyled__StyledImpersonationArea",
  componentId: "sc-13exct9-13"
})(function(_ref12) {
  var theme = _ref12.theme, showLogoutButton = _ref12.showLogoutButton;
  return (0, import_styled_components.css)(["display:flex;box-sizing:border-box;flex-direction:column;justify-content:center;align-items:center;padding:", ";width:288px;max-height:176px;background:", ";border:1px solid ", ";border-radius:4px;margin-bottom:24px;", ""], showLogoutButton.show ? "16px 24px 0 24px" : "16px 24px 24px 24px", theme.colors.beige[60], theme.colors.beige[180], (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["width:368px;"])));
});
var StyledLoggedInAsUserLabel = import_styled_components.default.label.withConfig({
  displayName: "AvatarCardstyled__StyledLoggedInAsUserLabel",
  componentId: "sc-13exct9-14"
})(function(_ref13) {
  var theme = _ref13.theme;
  return (0, import_styled_components.css)(["line-height:24px;font-size:", ";font-weight:", ";"], theme.typography.sizes.medium, theme.typography.weights.medium);
});
var StyledLoggedInAsUser = import_styled_components.default.h2.withConfig({
  displayName: "AvatarCardstyled__StyledLoggedInAsUser",
  componentId: "sc-13exct9-15"
})(function(_ref14) {
  var theme = _ref14.theme;
  return (0, import_styled_components.css)(["text-align:center;font-weight:450;font-size:", ";line-height:24px;margin:0;color:", ";word-break:break-all;"], theme.typography.sizes.medium, theme.colors.n[80]);
});
var StyledEndImpersonationButton = (0, import_styled_components.default)(import_Button.Button).withConfig({
  displayName: "AvatarCardstyled__StyledEndImpersonationButton",
  componentId: "sc-13exct9-16"
})(function(_ref15) {
  var theme = _ref15.theme, hasRoleSwitcher = _ref15.hasRoleSwitcher;
  return (0, import_styled_components.css)(["cursor:pointer;border-color:", ";justify-content:center;width:240px;margin:", ";&:active{background-color:", ";}"], theme.colors.beige[180], hasRoleSwitcher ? "8px 0 32px 0;" : "24px 0 32px 0;", theme.colors.pr[180]);
});
var StyledImpersonationTitle = import_styled_components.default.p.withConfig({
  displayName: "AvatarCardstyled__StyledImpersonationTitle",
  componentId: "sc-13exct9-17"
})(function(_ref16) {
  var theme = _ref16.theme;
  return (0, import_styled_components.css)(["font-family:", ";font-style:normal;font-weight:450;font-size:", ";line-height:24px;margin-top:8px;margin-bottom:-4px;"], theme.typography.fonts.primary, theme.typography.sizes.medium);
});
var StyledAvatarPopupWindowScroll = import_styled_components.default.div.withConfig({
  displayName: "AvatarCardstyled__StyledAvatarPopupWindowScroll",
  componentId: "sc-13exct9-18"
})(function(_ref17) {
  var heightPopup = _ref17.heightPopup, is400percent = _ref17.is400percent, isKebabMenu = _ref17.isKebabMenu, isStudentVariant = _ref17.isStudentVariant;
  return (0, import_styled_components.css)(["height:", ";overflow-y:auto;overflow-x:hidden;", ""], heightPopup === 0 || is400percent && (isStudentVariant || isKebabMenu) ? "auto" : "".concat(heightPopup, "px"), (0, import_mixins.withStyledScrollBar)());
});
var StyledAppSelectorContainer = import_styled_components.default.div.withConfig({
  displayName: "AvatarCardstyled__StyledAppSelectorContainer",
  componentId: "sc-13exct9-19"
})(function(_ref18) {
  var showAppSelector = _ref18.showAppSelector;
  return (0, import_styled_components.css)(["margin-bottom:50px;width:100%;display:", ";"], showAppSelector ? "block" : "none");
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledAppSelectorContainer,
  StyledAvatarPopupWindowScroll,
  StyledCard,
  StyledCloseButtonContainer,
  StyledEndImpersonationButton,
  StyledHeading,
  StyledImpersonationArea,
  StyledImpersonationTitle,
  StyledLinkItem,
  StyledLinks,
  StyledLinksContainer,
  StyledLinksCopyright,
  StyledLoggedInAsUser,
  StyledLoggedInAsUserLabel,
  StyledLogout,
  StyledLogoutToolTip,
  StyledParagraph,
  StyledRoleBadge,
  StyledRoleContainer,
  StyledText
});
//# sourceMappingURL=AvatarCard.styled.js.map